export enum PasswordStrengthInputMode {
  AUTOGENERATE = 'AUTOGENERATE',
  ENTER_PASSWORD = 'ENTER_PASSWORD',
}
